import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ConversationApiService, CustomerApiService } from '@dxp/core/api';
import { ICustomerDetails, ICustomFieldDefinition } from '@dxp/core/models';
import { JsonPatchData } from '@dxp/core/types';

@Injectable({
    providedIn: 'root',
})
export class EndCustomerApiService {
    readonly #customerApiService = inject(CustomerApiService);
    readonly #conversationApiService = inject(ConversationApiService);

    fetchCustomFields(
        businessUnitId: string | null,
    ): Observable<ICustomFieldDefinition[]> {
        return this.#customerApiService
            .getCustomFields(businessUnitId)
            .pipe(switchMap(customFields => [customFields.fieldDefinitions]));
    }

    retrieveCustomer(id: string): Observable<ICustomerDetails> {
        return this.#customerApiService.getCustomer(id, [
            'PhoneNumbers',
            'ExternalProfiles',
            'CustomFields',
        ]);
    }

    createCustomer(customer: ICustomerDetails): Observable<ICustomerDetails> {
        return this.#customerApiService.addCustomer(customer);
    }

    updateCustomer(
        customer: ICustomerDetails,
        patchData: JsonPatchData,
    ): Observable<ICustomerDetails> {
        return this.#customerApiService.updateCustomer(customer, patchData);
    }

    makeCustomerActive(
        customer: ICustomerDetails,
        conversationId: string,
    ): Observable<void> {
        return this.#conversationApiService.makeCustomerActive(
            customer,
            conversationId,
        );
    }

    mergeCustomers(
        sourceCustomer: ICustomerDetails,
        targetCustomer: ICustomerDetails,
    ): Observable<void> {
        return this.#customerApiService.mergeCustomers(
            sourceCustomer.customerId,
            targetCustomer.customerId,
        );
    }
}
